import React, { useEffect, useState } from 'react'

//MUI
import { Box, Container, Grid, Typography, Button, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MicIcon from '@mui/icons-material/Mic';

//Router dom
import { useParams, Link } from 'react-router-dom';

//Imagenes solo de prueba
import img_1 from '../../../Assets/Images/1080x920/card_1.jpg'

const RegisterButton = styled(Button)(({ theme }) => ({
  color: '#fff',
  width: '60%',
  borderRadius: '12px',
  padding: '15px',
  backgroundColor: '#2DC335',
  '&:hover': {
    backgroundColor: '#010845',
  },
}));

const WebinarsDetailContainer = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const { name } = useParams();

  useEffect(() => {
    const savedForms = JSON.parse(localStorage.getItem('webi')) || [];
    setData(savedForms.find(item => item.title === name))
    setLoading(true)
  }, [name]);

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    expired: false,
  });

  useEffect(() => {
    const date = new Date(`${data.date}T${data.time}`);
    const interval = setInterval(() => {
      const now = new Date();
      const df = date - now;

      if (df <= 0) {
        clearInterval(interval);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0, expired: true });
      } else {
        const days = Math.floor(df / (1000 * 60 * 60 * 24));
        const hours = Math.floor((df / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((df / (1000 * 60)) % 60);
        const seconds = Math.floor((df / 1000) % 60);

        setTimeLeft({ days, hours, minutes, seconds, expired: false });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [data.date, data.time]);

  const formatFecha = (dateString) => {
    const meses = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const date = new Date(dateString);
    const day = date.getDate();
    const month = meses[date.getMonth()];
    const year = date.getFullYear();

    return `${day} de ${month} del ${year}`;
  };

  const now = new Date()
  const eventDateTime = new Date(`${data.date}T${data.time}`)

  return (
    <>
      {
        loading
          ?
          <>
            <Container maxWidth='xl' sx={{ my: 6 }}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 1.5, mb: 2 }}>
                {now >= eventDateTime && data.isFinished !== true && <MicIcon color='error' className='online_icon' />}
                <Typography variant='body1' sx={{ fontSize: '28px', color: '#000C77', fontWeight: '600', lineHeight: 1.2 }}>{data.title}</Typography>
              </Box>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <CalendarMonthIcon sx={{ color: '#505256' }} />
                </Grid>
                <Grid item>
                  <Typography variant="body1">
                    <span style={{ fontWeight: 'bold', color: '#505256' }}>Fecha:</span> {formatFecha(data.date)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <AccessTimeIcon sx={{ color: '#505256' }} />
                </Grid>
                <Grid item>
                  <Typography variant="body1" >
                    <span style={{ color: '#505256', fontWeight: 'bold' }}>Hora:</span> {data.time} hrs (CDMX)
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <MicIcon sx={{ color: '#505256' }} />
                </Grid>
                <Grid item>
                  <Typography variant="body1">
                    <span style={{ fontWeight: 'bold', color: '#505256' }}>Modalidad:</span> {data.modality}
                  </Typography>
                </Grid>
              </Grid>
              <Box sx={{ mt: 5 }}>
                <div dangerouslySetInnerHTML={{ __html: data.description }} />
              </Box>
              <Box sx={{ mt: 5 }}>
                <Grid container spacing={3} justifyContent='center'>
                  <Grid item xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} sx={{ my: 'auto' }}>
                    <Box display="flex" sx={{ justifyContent: { xxl: 'flex-end', xl: 'flex-end', lg: 'flex-end', md: 'flex-end', sm: 'center', xs: 'center' } }}>
                      {/* Añadir este y quitar el activo */}
                      {/* {data.speakerImg && (
                        <img src={speakerImg} alt="ponente" style={{ width: '140px', height: '140px', borderRadius: '50%', objectFit: 'cover' }} />
                      )} */}
                      <img src={img_1} alt="ponente" style={{ width: '140px', height: '140px', borderRadius: '50%', objectFit: 'cover' }} />
                    </Box>
                  </Grid>
                  <Grid item xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}
                    sx={{ my: 'auto', textAlign: { xxl: 'left', xl: 'left', lg: 'left', md: 'left', sm: 'center', xs: 'center' } }}
                  >
                    <Typography variant='body1' sx={{ fontSize: '18px' }} gutterBottom>
                      PONENTE: <strong style={{ color: '#505256' }}>{data.speakerName}</strong>
                    </Typography>
                    <Box>
                      {data.specialties.length > 0 && (
                        <>
                          {data.specialties.map((res, index) => (
                            <span style={{ fontStyle: 'italic', color: '#505256' }} key={index}>
                              {res}
                              {index < data.specialties.length - 1 && " | "}
                            </span>
                          ))}
                        </>
                      )}
                    </Box>
                  </Grid>
                </Grid>
                <Box sx={{ mt: 5, textAlign: 'center' }}>
                  {
                    data.script !== '' && eventDateTime > now
                      ?
                      <RegisterButton variant='contained'>Registrame</RegisterButton>
                      :
                      data.script !== '' && now >= eventDateTime && data.isFinished !== true
                        ?
                        <RegisterButton variant='contained'>Ingresa aquí</RegisterButton>
                        :
                        <RegisterButton variant='contained'>Registro proximamente</RegisterButton>
                  }
                  <Box sx={{ display: 'flex', gap: 2, mt: 5, mb: 2, justifyContent: 'center' }}>
                    <Box sx={{ textAlign: 'center', border: '1px solid #ccc', width: '80px', borderRadius: '8px', py: 2 }}>
                      <Typography variant="h4" sx={{ color: '#000C77' }}>{timeLeft.days}</Typography>
                      <Typography variant="caption">Días</Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center', border: '1px solid #ccc', width: '80px', borderRadius: '8px', py: 2 }}>
                      <Typography variant="h4" sx={{ color: '#000C77' }}>{timeLeft.hours}</Typography>
                      <Typography variant="caption">Horas</Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center', border: '1px solid #ccc', width: '80px', borderRadius: '8px', py: 2 }}>
                      <Typography variant="h4" sx={{ color: '#000C77' }}>{timeLeft.minutes}</Typography>
                      <Typography variant="caption">Minutos</Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center', border: '1px solid #ccc', width: '80px', borderRadius: '8px', py: 2 }}>
                      <Typography variant="h4" sx={{ color: '#000C77' }}>{timeLeft.seconds}</Typography>
                      <Typography variant="caption">Segundos</Typography>
                    </Box>
                  </Box>
                  {
                    now >= eventDateTime && data.isFinished !== true
                      ?
                      <Typography variant='h6' color='error'>
                        Evento en vivo
                      </Typography>
                      :
                      timeLeft.expired && data.isFinished === true &&
                      <Typography variant='body1'>
                        Este webinar ya ha terminado <br />
                        consulta los próximos webinars en el siguiente enlace: <Link to='/webinars' style={{ textDecoration: 'none' }}>próximos webinars</Link>
                      </Typography>
                  }
                </Box>
              </Box>
              {/* <p><strong>Script:</strong> {data.script}</p> */}
            </Container>

            <Divider sx={{ my: 8 }} />
            <Container maxWidth='xl'>
              <Grid container spacing={4} sx={{ textAlign: { xxl: 'left', xl: 'left', lg: 'left', md: 'center', sm: 'center', xs: 'center' } }}>
                <Grid item xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} sx={{ my: 'auto' }}>
                  <Typography variant='h5' sx={{ color: '#000C77', fontWeight: '600' }}>Exclusivo para ti</Typography>
                </Grid>
                <Grid item xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} sx={{ my: 'auto' }}>
                  <Typography variant='body1'>Recibe un diploma de participación al finalizar la trasmisión en vivo. </Typography>
                </Grid>
              </Grid>
            </Container>
            <Divider sx={{ my: 8 }} />
            <Container maxWidth='xl'>
              <Grid container spacing={4} >
                <Grid item xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} sx={{ my: 'auto', textAlign: { xxl: 'left', xl: 'left', lg: 'left', md: 'center', sm: 'center', xs: 'center' } }}>
                  <Typography variant='h5' sx={{ color: '#000C77', fontWeight: '600' }}>¿A quién va dirigido?</Typography>
                </Grid>
                <Grid item xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} sx={{ my: 'auto' }}>
                  <Typography variant='body1' paragraph>👉 Nutriólogos, médicos, enfermeras, nefrólogos y otros profesionales de la salud.</Typography>
                  <Typography variant='body1' paragraph>👉 Estudiantes avanzados de nutrición y medicina.</Typography>
                  <Typography variant='body1'>
                    👉 Cualquier profesional que busque herramientas innovadoras y basadas en evidencia para el abordaje integral del paciente renal.
                  </Typography>
                </Grid>
              </Grid>
            </Container>
            <Divider sx={{ my: 8 }} />

            <div style={{ backgroundColor: '#eaeced', paddingTop: '30px', paddingBottom: '30px', marginBottom: '40px' }}>
              <Container maxWidth='xl'>
                <Grid container spacing={6}>
                  <Grid item xl={6} sx={{ my: 'auto' }}>
                    <Typography variant='h4' sx={{ color: '#000C77', fontWeight: '600' }} gutterBottom>
                      Ponente invitado: {data.speakerName}
                    </Typography>
                    <Box>
                      {data.specialties.length > 0 && (
                        <>
                          {data.specialties.map((res, index) => (
                            <span style={{ fontStyle: 'italic', color: '#505256' }} key={index}>
                              {res}
                              {index < data.specialties.length - 1 && " | "}
                            </span>
                          ))}
                        </>
                      )}
                    </Box>
                    <Box>
                      <div dangerouslySetInnerHTML={{ __html: data.speakerDescription }} />
                    </Box>
                  </Grid>
                  <Grid item xl={6} sx={{ my: 'auto', textAlign: 'center' }}>
                    {/* Añadir este y quitar el activo */}
                    {/* {data.speakerImg && (
                      <img src={speakerImg} alt="ponente" style={{ width: '70%', height: '100%', objectFit: 'cover', borderRadius: '6px' }} />
                    )} */}
                    <img src={img_1} alt="ponente" style={{ width: '70%', height: '100%', objectFit: 'cover', borderRadius: '6px' }} />
                  </Grid>
                </Grid>
              </Container>
            </div>

            {
              data.script !== ''
                ?
                <div style={{ width: '100%', height: '0px', position: 'relative', paddingBottom: '56.25%', marginBottom: '60px' }}>
                  <iframe src={data.script} width="100%" height="100%" frameBorder="0" allow="autoplay; fullscreen" title='NINWebinar'
                    style={{ width: '100%', height: '100%', position: 'absolute', left: '0px', top: '0px', overflow: 'hidden' }}></iframe>
                </div>
                :
                null
            }
          </>
          :
          <>cargando</>
      }
    </>
  )
}

export default WebinarsDetailContainer